import { Label, Modal, useToast } from '@ethsign/ui';
import React, { useState } from 'react';

import { PasswordInput } from '@/components';

import { PasswordManagerModal, usePasswordManagerModal } from '@/components/Modal/PasswordManagerModal';
import { SKIP_SET_PASSWORD_MANAGER } from '@/constants';
import { useUserInfo } from '@/hooks/useUserInfo';
import { isSupportPasswordManager, storageUtil, WalletType } from '@/utils';

export const SetPasswordManagerModal = ({ show }: { show: boolean }) => {
  const [openModal, setOpenModal] = useState(show);
  const { fetchUser, user } = useUserInfo();
  const isSupport = isSupportPasswordManager(user?.chainType as WalletType);
  const { toast } = useToast();
  const [masterPassword, setMasterPassword] = useState('');

  const onClose = () => {
    setOpenModal(false);
  };
  const handleConfirm = async () => {
    await onEnable(isSupport ? undefined : masterPassword);
    onClose();
  };

  const { open, onRetry, setOpen, steps, onEnable } = usePasswordManagerModal({
    onSuccess: async () => {
      fetchUser();
      onClose();
      toast({
        title: 'Success',
        description: 'Your have successfully enabled EthSign Password Manager. ',
        variant: 'success'
      });
    }
  });

  const onSkip = () => {
    storageUtil.set({
      key: SKIP_SET_PASSWORD_MANAGER,
      value: true,
      expire: '30_d'
    });
    onClose();
    toast({
      title: 'Success',
      description: 'You can set password manager later in Settings',
      variant: 'success'
    });
  };
  return (
    <>
      <Modal
        className="gap-0"
        maskClosable={false}
        open={openModal}
        onOpenChange={setOpenModal}
        cancelText="Skip"
        onCancel={onSkip}
        confirmText="Enable"
        onConfirm={handleConfirm}
        confirmButtonProps={{
          variant: 'primary',
          disabled: isSupport ? false : !masterPassword
        }}
      >
        <div className="flex flex-col items-center">
          <img
            className="w-[200px] h-[200px]"
            src="https://sign-public-cdn.s3.us-east-1.amazonaws.com/signature-next/ETHSIGN__Encryption_240723062916.webp"
          ></img>
          <div className="text-lg font-medium text-gray-900 my-2">EthSign Password Manager</div>
          <div className="text-sm font-normal text-gray-500">
            {isSupport
              ? 'Say goodbye to password hassles. EthSign Password Manager allows you to decrypt contract without remembering the password.'
              : 'Say goodbye to password hassles. Set a master password for your account and you can use it to decrypt all your contracts.'}
          </div>
          {isSupport ? null : (
            <div className={'w-full mb-[-12px] mt-[32px]'}>
              <Label className={'text-left w-full'}>Master Password</Label>
              <PasswordInput
                className={'mt-[6px]'}
                value={masterPassword}
                onChange={(e) => setMasterPassword(e.target.value)}
              />
            </div>
          )}
        </div>
      </Modal>
      <PasswordManagerModal open={open} onOpenChange={setOpen} onConfirm={onRetry} steps={steps} />
    </>
  );
};
